
function getUserIdFromToken() {
  const token = window.sessionStorage.getItem("token");
  if (!token) return null;

  try {

    const payload = JSON.parse(atob(token.split('.')[1])); 
    return payload.id || null; 
  } catch (error) {
    console.error("Invalid token format:", error);
    return null;
  }
}

 export const currentUserId = getUserIdFromToken();


export const checkAllFieldsFilled = (userData) => {
  const requiredFields = [
    userData?.firstName,
    userData?.lastName,
    userData?.age,
    userData?.gender,
    userData?.phnNumber,
    userData?.email,
    userData?.address?.houseNo,
    userData?.address?.street,
    userData?.address?.townCity,
    userData?.address?.postCode,
  ];

  return requiredFields.every((field) => field !== undefined && field !== "");
};